import { createAsyncAction } from 'typesafe-actions';
import type { FichesStatistiquesParameters, LevelUpStatistiques } from './types';

// Charge la liste des statistiques
export const loadStatistiquesAsync = createAsyncAction(
    'LOAD_GENERAL_STATISTIQUES_REQUEST',
    'LOAD_GENERAL_STATISTIQUES_SUCCESS',
    'LOAD_GENERAL_STATISTIQUES_FAILURE',
)<FichesStatistiquesParameters, LevelUpStatistiques, string>();
